import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, DateDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { CustomerPrivate } from './Customer';
import { Promotion } from './Promotion';
export class OrderSettings extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.amount = 1;
        this.orderToAllMyClients = false;
    }
}
__decorate([
    field({ decoder: Promotion })
], OrderSettings.prototype, "promotion", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], OrderSettings.prototype, "amount", void 0);
__decorate([
    field({ decoder: BooleanDecoder, optional: true })
], OrderSettings.prototype, "orderToAllMyClients", void 0);
export class Order extends AutoEncoder {
}
__decorate([
    field({ decoder: StringDecoder })
], Order.prototype, "id", void 0);
__decorate([
    field({ decoder: OrderSettings })
], Order.prototype, "settings", void 0);
__decorate([
    field({ decoder: DateDecoder })
], Order.prototype, "createdAt", void 0);
export class OrderPrivate extends Order {
}
__decorate([
    field({ decoder: CustomerPrivate })
], OrderPrivate.prototype, "customer", void 0);
// Fix for reference loop
export class PromotionCustomer extends Promotion {
    constructor() {
        super(...arguments);
        this.orders = [];
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(Order), version: 17 })
], PromotionCustomer.prototype, "orders", void 0);
//# sourceMappingURL=Order.js.map